// extracted by mini-css-extract-plugin
export default {"armyControl":"ArmyControl_armyControl__Tcc4q"};